'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Shown while a track-gated screen sends the learner to the catalog instead
 * of building a fixture session (issue #283) — no app surface may fall back
 * to a hardcoded ecosystem/route when nothing has been selected yet.
 */
export default function RedirectToCatalog() {
  const router = useRouter();

  useEffect(() => {
    router.replace('/catalog');
  }, [router]);

  return (
    <div className="route-loading" role="status" aria-live="polite" aria-busy="true">
      <span className="spinner" aria-hidden="true" />
      <span className="sr-only">Redirecting to the track catalog</span>
    </div>
  );
}
